/**
 * Voice-agent endpoint configuration shared by the settings UI.
 *
 * The Cloud Run service URL is stable as long as the project doesn't move,
 * so we hardcode it here and surface it in copy buttons next to the
 * provider config fields. If the project ever migrates we override via
 * the optional Vite env var.
 */

const DEFAULT_BASE_HTTPS =
  'https://voice-agent-1019188911793.europe-west3.run.app';

export const VOICE_AGENT_BASE_HTTPS: string =
  (import.meta.env.VITE_VOICE_AGENT_URL as string | undefined) ?? DEFAULT_BASE_HTTPS;

export const VOICE_AGENT_BASE_WSS: string = VOICE_AGENT_BASE_HTTPS.replace(
  /^https?:\/\//,
  'wss://',
);

export const TWILIO_INBOUND_WEBHOOK = `${VOICE_AGENT_BASE_HTTPS}/twilio/incoming`;
export const TELNYX_INBOUND_WEBHOOK = `${VOICE_AGENT_BASE_HTTPS}/telnyx/incoming`;
export const TWILIO_CONVERSATION_RELAY_URL = `${VOICE_AGENT_BASE_WSS}/voice/twilio`;
export const TELNYX_MEDIA_FORK_URL = `${VOICE_AGENT_BASE_WSS}/voice/telnyx`;
